<script>
  import {Doughnut, mixins} from 'vue-chartjs'
  // import the component - chart you need

  // Extend it
  export default {
    extends: Doughnut,
    //mixins: [mixins.reactiveProp],
    props: ['staffCheckedInCount','staffAbsentCount'],
    data() {
        var _this = this;
        return {
            datacollection: {
                labels: ['Checked In', 'Absent'],
                datasets: [
                    {
                        label: 'Staff Attendance for today',
                        backgroundColor: ['#088914',"#CCCCCC"],
                        data: [this.staffCheckedInCount, this.staffAbsentCount],
                    }
                ]
            },
            options: {
                responsive: false,
                maintainAspectRatio: false,
                legend: {
                    display: false,
                    position: 'right'
                },
                onClick: function(evt,arr) {
                    _this.graphClickEvent(evt,arr);
                }
            }
        }
    },
    created(){
    },
    methods: {
        graphClickEvent(evt,arr){
            var label = arr[0]['_model'].label
            var index = arr[0]['_index']

            var data = 1;

            if (index == 0){
                data = 1   //came
            }else{
                data = 2   //absent
            }
            
            this.$store.commit('UPDATE_VIEW_STAFF_ATTENDANCE',data)
            localStorage.setItem('VIEW_STAFF_ATTENDANCE',data)

            this.$router.push({
                name: "DisplayStaffAttendance"
            });
        }
    },
    mounted () {
      this.renderChart(this.datacollection, this.options)
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Charts/StaffAttendanceDaily.vue